import React from 'react';
import styled from 'styled-components';
import Page from '../components/Page';

// STYLES

// COMPONENT
const ImprintPrivacy = props => {
  
  console.log(props);
  const { data } = props;

  return (
    <Page title="Impressum und Datenschutz">
      <div dangerouslySetInnerHTML={{ __html: data.imprint }}></div>
      <div dangerouslySetInnerHTML={{ __html: data.privacy_policy }}></div>
    </Page>
  );
};

export default ImprintPrivacy;